import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="31c9ygdv1bhw7">
    <p className="text-2xl md:text-4xl font-serif italic text-brand-burgundy leading-relaxed font-medium" data-id="element-1" data-mp="2wj8g1vvmd07v">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-purple/25 selection:text-brand-purpleDark bg-brand-surface" data-id="element-2" data-mp="23ujho4ly78zt">
      <UrgencyBanner data-id="element-3" data-mp="3ii4ppvcl6gle" />
      <Hero data-id="element-4" data-mp="3ml13n8r6loj0" />
      <PackContents data-id="element-5" data-mp="3mkrgdsxitvh0" />
      <InitialTestimonials data-id="element-6" data-mp="3mjzsl4a6121a" />
      <PainPoints data-id="element-7" data-mp="3mj6ipufwtwex" />
      <MethodOverview data-id="element-8" data-mp="3rcj6y3gog175" />
      <MoreTestimonials data-id="element-9" data-mp="3rbzngibdp4r0" />
      <Guarantee data-id="element-10" data-mp="3rcsw5otwe4bs" />
      <FAQ data-id="element-11" data-mp="3recd7hndojem" />
      <CostComparison data-id="element-12" data-mp="3relwynhtxubv" />
      <TransitionPhrase data-id="element-13" data-mp="6hr7hlrojf6" />
      <EmotionalClose data-id="element-14" data-mp="4n4bxqxqh8g" />
      <Footer data-id="element-15" data-mp="56m9egl55mh" />
      <FloatingNotification data-id="element-16" data-mp="7suzhf7pr6a" />
    </div>;
}